import type { CategoryView } from '@pz/server';
import { useQ } from './hooks';
import { lang } from './format';

export function categoryName(c: Pick<CategoryView, 'nameDe' | 'nameEn' | 'nameTr'>): string {
  const l = lang();
  return (l === 'en' ? c.nameEn : l === 'tr' ? c.nameTr : c.nameDe) || c.nameDe;
}

/** Active categories with names in the UI language; label(key) falls back to the key for removed ones. */
export function useCategories(enabled = true) {
  const q = useQ('categories.list', {}, { enabled, staleTime: 5 * 60_000 });
  const list = q.data?.categories ?? [];
  const byKey = new Map(list.map((c) => [c.key, c]));
  return {
    list,
    loading: q.isLoading,
    label: (key: string | null | undefined) => {
      if (!key) return '';
      const c = byKey.get(key);
      return c ? categoryName(c) : key;
    },
    get: (key: string) => byKey.get(key),
  };
}
